// extracted by mini-css-extract-plugin
export default {"content":"TqDXP","stub":"Q4a2m","projects":"QpYND","grid":"Mf8m8","addProjectBtn":"So2OU","plus":"JKeXi"};